<template>
  <app-modal width="50%" name="detailed-notification-modal" :title="title" @before-open="beforeOpen" @before-close="beforeClose" hide-footer>
    <div class="notification-modal-container">
      <div class="header">
        <div class="title">
          <b-form-checkbox v-model="checkAll" @change="onCheckAllChanged">
          </b-form-checkbox>
          <span>{{ renderLabelInvoices }}</span>
        </div>
        <span v-show="Array.from(this.selectedInvoices).length === 0" >{{$t('reconciliation.reconciliation')}}</span>
        <button
          v-show="Array.from(this.selectedInvoices).length > 0"
          class="btn btn-sm btn-primary"
          @click="onClickApproveInvoices"
        >
          {{$t('reconciliation.reconciliation')}}
        </button>
      </div>
      <div class="content">
        <invoice-list
           v-if="loading || loadMoreLoading || invoices.length !== 0"
          :loading="loading"
          :show-filter="false"
          :is-reconciliation="true"
          :paging="paging"
          :invoices="invoices"
          :selected-invoices="selectedInvoices"
          :loadMoreInvoiceLoading="loadMoreLoading"
          @on-reconciliation="onConfirmInvoice"
          @on-click="onClickInvoice"
          @on-load-more="onLoadMore"
        ></invoice-list>
        <div v-else class="flex-row-center">
          <strong style="color: #005DCA">
            No data for invoice list
          </strong>
        </div>
      </div>
    </div>
  </app-modal>
</template>
<script>
import { mapActions } from 'vuex';
import AppModal from '@/components/app-modal/';
import InvoiceList from '@/portal-components/invoice/invoice-list';
import AccountProxy from '@/store/proxies/account-proxy';
import InvoiceProxy from '@/store/proxies/invoice-proxy';
import { PAGE_LIMIT, NOTIFICATION_TYPE } from '@/app-constant';
import NumericUtils from '@/utils/numeric';

/*
TODO: Add tags to notification invoice list ( it is not coupled with vuex's invoiceList )
*/

export default {
  name: 'DetailedNotificationModal',
  components: {
    AppModal,
    InvoiceList,
  },
  data() {
    return {
      loading: false,
      loadMoreLoading: false,
      title: this.$t('notification.notificationDetails'),
      invoices: [],
      params: {},
      checkAll: false,
      selectedInvoices: new Set(),
      notification: {},
      paging: {
        page: 1,
        total: 0,
        limit: PAGE_LIMIT,
      },
    };
  },
  created() {
    this.$bus.on('on-selected-item-changed', this.onCheckInvoiceChanged);
    this.$bus.on('on-select-tags', this.onSelectTags);
    this.$bus.on('on-confirm-invoice-success', this.onConfirmInvoiceSuccess);
    this.$bus.on('verify-invoice-success', this.onVerifyInvoiceSuccess);
    this.$bus.on('invoice-viewer-load-more', this.onLoadMore);
  },
  beforeDestroy() {
    this.$bus.off('on-selected-item-changed', this.onCheckInvoiceChanged);
    this.$bus.off('on-select-tags', this.onSelectTags);
    this.$bus.off('on-confirm-invoice-success', this.onConfirmInvoiceSuccess);
    this.$bus.off('verify-invoice-success', this.onVerifyInvoiceSuccess);
    this.$bus.off('invoice-viewer-load-more', this.onLoadMore);
  },
  computed: {
    renderLabelInvoices() {
      switch (this.notification.type) {
        case NOTIFICATION_TYPE.SYNC_PROCESS_0_SUCCESS:
        case NOTIFICATION_TYPE.SYNC_PROCESS_1_SUCCESS:
        case NOTIFICATION_TYPE.SYNC_PROCESS_2_SUCCESS:
          if (this.notification.content && this.notification.content.total_invoices) {
            return `${this.$t('notification.modal.detailNotification.title.1')} ${this.notification.content.start_date} ${this.$t('notification.modal.detailNotification.title.2')} ${this.notification.content.end_date} (${NumericUtils.formatAmount(this.notification.content.total_invoices)})`;
          }
          return '';
        case NOTIFICATION_TYPE.RELEASE_INVOICE_SUCCESS:
          return `${this.notification.title}`;
        default:
          return '';
      }
    },
  },
  methods: {
    ...mapActions([
      'setState',
      'markAsRead',
      'checkValidCustomer',
    ]),
    beforeOpen(data) {
      this.notification = data.notification || {};
      this.params = data.params || {};
      this.fetchData(false);
    },
    beforeClose() {
      this.invoices = [];
      this.checkAll = false;
      this.selectedInvoices = new Set();
      this.paging = {
        page: 1,
        total: 0,
        limit: PAGE_LIMIT,
      };
    },
    confirmInvoices(invoiceIds) {
      this.$modal.show('dialog', {
        title: this.$t('reconciliation.invoiceReconciliation'),
        text: this.$t('app.confirmValidInvoice'),
        okText: this.$t('app.confirm'),
        okClass: 'btn btn-primary btn-sm',
        showLoading: true,
        onOk: () => {
          new AccountProxy().confirmInvoices(invoiceIds).then((res) => {
            if (res && res.length > 0) {
              this.onConfirmInvoiceSuccess(res);
            }
          });
        },
      });
    },
    onCheckInvoiceChanged(param) {
      const { id, isSelected } = param;
      this.selectedInvoices = new Set([...this.selectedInvoices]);
      if (isSelected) {
        this.selectedInvoices.add(id);
      } else {
        this.selectedInvoices.delete(id);
      }
      this.checkAll = this.selectedInvoices.size === this.invoices.length;
    },
    onClickInvoice(invoice) {
      this.$modal.show('invoice-viewer-modal', {
        model: invoice,
      });
    },
    onConfirmInvoice(invoice, $event) {
      $event.preventDefault();
      $event.stopPropagation();
      this.confirmInvoices([invoice.id]);
    },
    onConfirmInvoiceSuccess(invoiceIds) {
      if (invoiceIds.length > 0) {
        const Ids = new Set(invoiceIds);
        this.invoices = this.invoices.map((invoice) => {
          if (Ids.has(invoice.id)) {
            return { ...invoice, origin: '4' };
          }
          return invoice;
        });
      }
    },
    onClickApproveInvoices() {
      this.confirmInvoices(Array.from(this.selectedInvoices));
    },
    onCheckAllChanged(checkAll) {
      this.checkAll = checkAll;
      this.selectedInvoices = new Set();
      if (checkAll) {
        this.invoices.forEach(invoice => this.selectedInvoices.add(invoice.id));
      }
    },
    onLoadMore(pagingInfo) {
      switch (this.notification.type) {
        case NOTIFICATION_TYPE.SYNC_PROCESS_0_SUCCESS:
        case NOTIFICATION_TYPE.SYNC_PROCESS_1_SUCCESS:
        case NOTIFICATION_TYPE.SYNC_PROCESS_2_SUCCESS:
          this.paging = { ...this.paging, page: pagingInfo.page + 1 };
          return this.fetchData(true);
        default:
          return undefined;
      }
    },
    async fetchData(loadMore = false) {
      if (loadMore) {
        this.loadMoreLoading = true;
        this.setState({ invoiceListLoading: true });
      } else {
        this.loading = true;
      }
      const params = {
        page_size: PAGE_LIMIT,
        page: loadMore ? this.paging.page : undefined,
        ...this.params,
      };
      await new InvoiceProxy(params).getInvoices()
        .then((res) => {
          if (res.success && res.data.length > 0) {
            this.invoices = loadMore ? [...this.invoices, ...res.data] : res.data;
            this.paging = { ...this.paging, ...res.page_info };
            this.selectedInvoices = new Set();
            this.checkAll = false;
            this.setState({
              invoiceList: this.invoices,
              invoiceListPageInfo: res.page_info,
            });
            if (!loadMore && !this.notification.is_readed) {
              this.markAsRead([this.notification.id]);
            }
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
          this.loadMoreLoading = false;
          this.setState({ invoiceListLoading: false });
        });
    },
    onVerifyInvoiceSuccess(invoiceVerified) {
      if (invoiceVerified) {
        const {
          kindOf,
          buyerTaxCode,
          sellerTaxCode,
          customerInvalidData,
        } = invoiceVerified;
        this.invoices = this.invoices.map((invoice) => {
          if (invoice.kind_of === kindOf && invoice.buyer_taxcode === buyerTaxCode && invoice.seller_taxcode === sellerTaxCode) {
            return { ...invoice, customer_invalid_data: customerInvalidData };
          }
          return invoice;
        });
      }
    },
    onSelectTags(formTags, invoiceId) {
      const invoiceIndex = this.invoices.findIndex(invoice => invoice.id === invoiceId)
      this.$set(this.invoices, invoiceIndex, { ...this.invoices[invoiceIndex], tags: formTags });
    }
  },
};
</script>
<style lang="scss">
#detailed-notification-modal {
  .modal-body {
    position: relative;
    padding: 0;
    .notification-modal-container {
      .header {
        color: #005DCA;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 16px 16px 32px;
        margin-bottom: 12px;
        border-bottom: 2px solid #005DCA;
        position: sticky;
        top: 0;
        right: 0;
        left: 0;
        background-color: white;
        z-index: 10;
        .title {
          gap: 20px;
          display: flex;
          margin-left: 8px;
          align-items: center;
        }
        button {
          font-weight: bold;
          font-size: 16px;
        }
      }
      .content {
        padding-left: 1rem;
        padding-bottom: 1rem;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/portal-components/notification/detailed-notification-modal.vue